export default "__VITE_ASSET__2feb1a41__"